import { createContext, useContext } from 'react';
export const MobileLoginContext = /*#__PURE__*/createContext(true);
export const useIsMobileLogin = () => useContext(MobileLoginContext);